__turbopack_context__.v({
  "link": "FeatureGrid-module-scss-module__kjT5Gq__link",
});
